export class Maestro_Aliados {
    id: number;
    idAplicacion: number;
    nombre: string;
    idSector: number;
    sector: string;
    nroIdentificacion: string;
    domicilio: string;
    provincia: string;
    provinciaDescripcion: string;
    ciudad: string;
    ciudadDescripcion: string;
    activo: boolean;
    manejaCartera: boolean;
    registrar: boolean;
    calculoPrecioEdad: boolean;
    notificarCambios: boolean;
    recaudoWeb: boolean;
    filtrarProductoCanal: boolean;
    cargarProspectos: boolean;
    filtroFormatoProspecto: string;
    nombreFormatoProspecto: string;
    manejaProgramas: boolean;
    expedientes: boolean;
    cambioEstadoAfiliacion: boolean;
    migracionClientesAliados: boolean;
    nombreClientesAliados: string;
    nombreBaseDatos: string;
}